import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";
const style = () => {
    const { space2 } = theme();
    return StyleSheet.create({
        container: {
            flex: 1,
        },
        text: {
            marginTop: space2,
        },
    });
};
export { style };
